import React from 'react';
import { matchPath, useLocation } from 'react-router-dom';
import { useDocumentTitle } from '../hooks/useDocumentTitle';

/** Статичные заголовки по маршрутам (от более специфичных к общим). */
const ROUTE_TITLES: Array<{ path: string; title: string }> = [
  { path: '/login', title: 'Вход в систему' },
  { path: '/dashboard-oup4', title: 'Портфель ОУП' },
  { path: '/contractors/:id', title: 'Контрагент' },
  { path: '/contractors', title: 'Контрагенты' },
  { path: '/contracts/:id', title: 'Договор' },
  { path: '/contracts', title: 'Договоры' },
  { path: '/in-progress/contracts', title: 'Договоры в работе' },
  { path: '/closing/managment', title: 'Даты закрытия' },
  { path: '/closing/contracts', title: 'Закрытие договоров' },
  { path: '/closing/stages', title: 'Закрытие этапов' },
  { path: '/closing/tasks', title: 'Закрытие задач' },
  { path: '/in-progress/tasks', title: 'Задачи в работе' },
  { path: '/tasks/:id', title: 'Задача' },
  { path: '/tasks', title: 'Задачи' },
  { path: '/register/create', title: 'Создать контрагента /договор / задачу' },
  { path: '/operations', title: 'Операции' },
  { path: '/finance/payment-requests', title: 'Заявка на ДС' },
  { path: '/finance/payment-requests-view', title: 'Мои заявки' },
  { path: '/finance/payment-approvals', title: 'Согласование' },
  { path: '/finance/payment-issues', title: 'Выдача ДС' },
  { path: '/finance/payment-distribution', title: 'Распределение' },
  { path: '/finance/payment-view', title: 'Поступления' },
  { path: '/settings/masterdata/articles', title: 'Статьи' },
  { path: '/settings/masterdata/taxes', title: 'Налоги' },
  { path: '/settings/masterdata/cash', title: 'Кэш' },
  { path: '/settings/masterdata/serv-fee', title: 'Сервисный сбор' },
  { path: '/admin/access', title: 'Роли и Модули' },
  { path: '/settings/access/articles', title: 'Доступы к Статьям Расходов' },
  { path: '/', title: 'Главная' },
];

function titleForPathname(pathname: string): string | undefined {
  for (const route of ROUTE_TITLES) {
    if (matchPath({ path: route.path, end: true }, pathname)) {
      return route.title;
    }
  }
  return undefined;
}

/**
 * Синхронизирует вкладку браузера с текущим маршрутом.
 * На страницах деталей можно уточнить заголовок через useDocumentTitle.
 */
const DocumentTitle: React.FC = () => {
  const { pathname } = useLocation();
  useDocumentTitle(titleForPathname(pathname));
  return null;
};

export default DocumentTitle;
